import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DeleteAccountDialogService } from './delete-account-dialog.service';

import { DeleteAccountDialogComponent } from './delete-account-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
  ],
  declarations: [DeleteAccountDialogComponent],
  exports: [DeleteAccountDialogComponent],
  providers: [DeleteAccountDialogService],
})
export class DeleteAccountDialogModule {}
